import { upperFirst } from 'lodash';

const getShapeType = shape => upperFirst(shape.get('type'));

export default getShapeType;
